import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

// Attach bearer token from localStorage as a fallback to the cookie
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("tp_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Ocorreu um erro.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export const CARRIER_LABELS = {
    NACEX: "NACEX",
    CORREOS_EXP: "CORREOS EXP.",
    CTT: "CTT",
    DPD: "DPD",
    OUTRA: "OUTRA",
};

export const CARRIER_STYLES = {
    NACEX: "bg-blue-50 text-blue-700 border-blue-200",
    CORREOS_EXP: "bg-yellow-50 text-yellow-700 border-yellow-200",
    CTT: "bg-red-50 text-red-700 border-red-200",
    DPD: "bg-rose-50 text-rose-700 border-rose-200",
    OUTRA: "bg-slate-100 text-slate-700 border-slate-200",
};
